import React, { createContext, useContext, useState } from "react";
import { BASE_URL } from "../config/config";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchUsers = async () => {
    setLoading(true);
    setError("");

    try {
      const token = localStorage.getItem("token");

      const res = await fetch(`${BASE_URL}/users`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();
console.log("users", data)
      if (res.ok && data.status === 200) {
        setUsers(data.data); // adjust if API key differs
      } else {
        setError(data?.message || "Failed to fetch users");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

   // ✅ TOGGLE STATUS API
  const toggleUserStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

    // ✅ Get user id from localStorage
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const updateAuditId = user.id; // fallback to 1 if not found

    try {
        const res = await fetch(`${BASE_URL}/users/status/${id}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ 
            status: newStatus,
            update_audit_id: updateAuditId
        }),
        });

        const data = await res.json();

        if (res.ok && data.status === 200) {
        // ✅ Update UI instantly
        setUsers((prev) =>
            prev.map((u) =>
            u.id === id ? { ...u, status: newStatus } : u
            )
        );
        } else {
        alert(data.message || "Failed to update status");
        }
    } catch {
        alert("Network error");
    }
    };


  const deleteUser = async (id) => {
  if (!window.confirm("Delete this user?")) return;

  // ✅ Get user id from localStorage
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const deleteAuditId = user.id || 1; // fallback to 1 if not found

  try {
    const res = await fetch(`${BASE_URL}/users/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ delete_audit_id: deleteAuditId }),
    });

    const data = await res.json();

    if (res.ok && data.status === 200) {
      // ✅ Update UI instantly
      setUsers((prev) => prev.filter((u) => u.id !== id));
    } else {
      alert(data.message || "Failed to delete user");
    }
  } catch (err) {
    console.error("Delete user error:", err);
    alert("Failed to delete user");
  }
};


  return (
    <UserContext.Provider
      value={{
        users,
        loading,
        setUsers,
        error,
        fetchUsers,
        toggleUserStatus,
        deleteUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUsers = () => useContext(UserContext);
